var $8Bz8p$react = require("react");
var $8Bz8p$reactjsxruntime = require("react/jsx-runtime");
var $8Bz8p$styledcomponents = require("styled-components");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Note", {
    enumerable: true,
    get: function get() {
        return $e02d8a7d375d9267$exports.Note;
    }
});
var $e02d8a7d375d9267$exports = {};
"use strict";
Object.defineProperty($e02d8a7d375d9267$exports, "__esModule", {
    value: true
});
$e02d8a7d375d9267$exports.Note = void 0;

var $e02d8a7d375d9267$var$_react = $e02d8a7d375d9267$var$_interopRequireDefault($8Bz8p$react);
var $2569c38112180295$exports = {};
"use strict";
function $2569c38112180295$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2569c38112180295$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2569c38112180295$var$_typeof(o);
}
Object.defineProperty($2569c38112180295$exports, "__esModule", {
    value: true
});
$2569c38112180295$exports.colorStyles = $2569c38112180295$exports.Wrapper = $2569c38112180295$exports.Title = $2569c38112180295$exports.PrefixIConWrapper = $2569c38112180295$exports.NoteHeader = $2569c38112180295$exports.Message = $2569c38112180295$exports.CloseIcon = void 0;
var $c589462aca75b6d0$exports = {};
"use strict";
Object.defineProperty($c589462aca75b6d0$exports, "__esModule", {
    value: true
});
Object.defineProperty($c589462aca75b6d0$exports, "CloseIcon", {
    enumerable: true,
    get: function get() {
        return $14e7d98ab022b44a$exports.CloseIcon;
    }
});
var $14e7d98ab022b44a$exports = {};
"use strict";
Object.defineProperty($14e7d98ab022b44a$exports, "__esModule", {
    value: true
});
$14e7d98ab022b44a$exports.CloseIcon = void 0;

var $14e7d98ab022b44a$var$_react = $14e7d98ab022b44a$var$_interopRequireDefault($8Bz8p$react);


function $14e7d98ab022b44a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $14e7d98ab022b44a$var$CloseIcon = $14e7d98ab022b44a$exports.CloseIcon = function CloseIcon(_ref) {
    var className = _ref.className, _ref$colorCode = _ref.colorCode, colorCode = _ref$colorCode === void 0 ? "p500" : _ref$colorCode, _ref$width = _ref.width, width = _ref$width === void 0 ? 7 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 8 : _ref$height, onClick = _ref.onClick, _ref$stroke = _ref.stroke, stroke = _ref$stroke === void 0 ? 0.7 : _ref$stroke;
    var theme = (0, $8Bz8p$styledcomponents.useTheme)();
    var color = theme.color[colorCode];
    return /*#__PURE__*/ (0, $8Bz8p$reactjsxruntime.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 7 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $8Bz8p$reactjsxruntime.jsx)("path", {
                d: "M0.6875 6.8125L6.3125 1.1875",
                stroke: color,
                strokeWidth: stroke,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8Bz8p$reactjsxruntime.jsx)("path", {
                d: "M0.6875 1.1875L6.3125 6.8125",
                stroke: color,
                strokeWidth: stroke,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};





var $2569c38112180295$var$_styledComponents = $2569c38112180295$var$_interopRequireWildcard($8Bz8p$styledcomponents);
var $2569c38112180295$var$_templateObject, $2569c38112180295$var$_templateObject2, $2569c38112180295$var$_templateObject3, $2569c38112180295$var$_templateObject4, $2569c38112180295$var$_templateObject5, $2569c38112180295$var$_templateObject6, $2569c38112180295$var$_templateObject7, $2569c38112180295$var$_templateObject8, $2569c38112180295$var$_templateObject9;
function $2569c38112180295$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2569c38112180295$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2569c38112180295$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $2569c38112180295$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $2569c38112180295$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2569c38112180295$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $2569c38112180295$var$colorStyles = $2569c38112180295$exports.colorStyles = {
    warning: (0, $2569c38112180295$var$_styledComponents.css)($2569c38112180295$var$_templateObject || ($2569c38112180295$var$_templateObject = $2569c38112180295$var$_taggedTemplateLiteral([
        "\n    background-color: ",
        ";\n    color: ",
        ";\n  "
    ])), function(props) {
        return props.theme.color.a100;
    }, function(props) {
        return props.theme.color.a600;
    }),
    alert: (0, $2569c38112180295$var$_styledComponents.css)($2569c38112180295$var$_templateObject2 || ($2569c38112180295$var$_templateObject2 = $2569c38112180295$var$_taggedTemplateLiteral([
        "\n    background-color: ",
        ";\n    color: ",
        ";\n  "
    ])), function(props) {
        return props.theme.color.e100;
    }, function(props) {
        return props.theme.color.e600;
    }),
    info: (0, $2569c38112180295$var$_styledComponents.css)($2569c38112180295$var$_templateObject3 || ($2569c38112180295$var$_templateObject3 = $2569c38112180295$var$_taggedTemplateLiteral([
        "\n    background-color: ",
        ";\n    color: ",
        ";\n  "
    ])), function(props) {
        return props.theme.color.p100;
    }, function(props) {
        return props.theme.color.p500;
    })
};
var $2569c38112180295$var$Wrapper = $2569c38112180295$exports.Wrapper = $2569c38112180295$var$_styledComponents["default"].div($2569c38112180295$var$_templateObject4 || ($2569c38112180295$var$_templateObject4 = $2569c38112180295$var$_taggedTemplateLiteral([
    "\n  ",
    ";\n  padding: 16px;\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n"
])), function(props) {
    return $2569c38112180295$var$colorStyles[props.$type];
});
var $2569c38112180295$var$NoteHeader = $2569c38112180295$exports.NoteHeader = $2569c38112180295$var$_styledComponents["default"].div($2569c38112180295$var$_templateObject5 || ($2569c38112180295$var$_templateObject5 = $2569c38112180295$var$_taggedTemplateLiteral([
    "\n  display: flex;\n  align-items: center;\n"
])));
var $2569c38112180295$var$PrefixIConWrapper = $2569c38112180295$exports.PrefixIConWrapper = $2569c38112180295$var$_styledComponents["default"].div($2569c38112180295$var$_templateObject6 || ($2569c38112180295$var$_templateObject6 = $2569c38112180295$var$_taggedTemplateLiteral([
    "\n  display: flex;\n  align-items: center;\n  margin-right: 10px;\n"
])));
var $2569c38112180295$var$CloseIcon = $2569c38112180295$exports.CloseIcon = (0, $2569c38112180295$var$_styledComponents["default"])($c589462aca75b6d0$exports.CloseIcon)($2569c38112180295$var$_templateObject7 || ($2569c38112180295$var$_templateObject7 = $2569c38112180295$var$_taggedTemplateLiteral([
    "\n  margin-left: auto;\n  cursor: pointer;\n  flex-shrink: 0;\n"
])));
var $2569c38112180295$var$Title = $2569c38112180295$exports.Title = $2569c38112180295$var$_styledComponents["default"].div($2569c38112180295$var$_templateObject8 || ($2569c38112180295$var$_templateObject8 = $2569c38112180295$var$_taggedTemplateLiteral([
    "\n  ",
    ";\n  ",
    ";\n  margin-right: 10px;\n"
])), function(props) {
    return props.theme.typo[props.$hasMessage ? "displayXS" : "bodyM"];
}, function(props) {
    return props.theme.fontWeight[props.$hasMessage ? "bold" : "medium"];
});
var $2569c38112180295$var$Message = $2569c38112180295$exports.Message = $2569c38112180295$var$_styledComponents["default"].div($2569c38112180295$var$_templateObject9 || ($2569c38112180295$var$_templateObject9 = $2569c38112180295$var$_taggedTemplateLiteral([
    "\n  ",
    ";\n  ",
    ";\n  ",
    ";\n"
])), function(props) {
    return props.theme.typo.bodyM;
}, function(props) {
    return props.theme.fontWeight.regular;
}, function(props) {
    return props.$hasTitle ? "margin-top: 6px" : "";
});


var $ec397517eee808ea$exports = {};
"use strict";
Object.defineProperty($ec397517eee808ea$exports, "__esModule", {
    value: true
});
$ec397517eee808ea$exports.MAP_ICON_WITH_TYPE = $ec397517eee808ea$exports.ICON_COLOR_MAP = void 0;
var $b2824a5fc00eb4c3$exports = {};
"use strict";
Object.defineProperty($b2824a5fc00eb4c3$exports, "__esModule", {
    value: true
});
Object.defineProperty($b2824a5fc00eb4c3$exports, "InfoFillIcon", {
    enumerable: true,
    get: function get() {
        return $48cd02f2475b8432$exports.InfoFillIcon;
    }
});
var $48cd02f2475b8432$exports = {};
"use strict";
Object.defineProperty($48cd02f2475b8432$exports, "__esModule", {
    value: true
});
$48cd02f2475b8432$exports.InfoFillIcon = void 0;

var $48cd02f2475b8432$var$_react = $48cd02f2475b8432$var$_interopRequireDefault($8Bz8p$react);


function $48cd02f2475b8432$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $48cd02f2475b8432$var$InfoFillIcon = $48cd02f2475b8432$exports.InfoFillIcon = function InfoFillIcon(_ref) {
    var className = _ref.className, _ref$colorCode = _ref.colorCode, colorCode = _ref$colorCode === void 0 ? "a600" : _ref$colorCode, _ref$width = _ref.width, width = _ref$width === void 0 ? 18 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 19 : _ref$height;
    var theme = (0, $8Bz8p$styledcomponents.useTheme)();
    var color = theme.color[colorCode];
    return /*#__PURE__*/ (0, $8Bz8p$reactjsxruntime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 19",
        className: className,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8Bz8p$reactjsxruntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.1998 9.50005C16.1998 11.4096 15.4412 13.241 14.091 14.5912C12.7407 15.9415 10.9094 16.7 8.9998 16.7C7.09025 16.7 5.2589 15.9415 3.90864 14.5912C2.55837 13.241 1.7998 11.4096 1.7998 9.50005C1.7998 7.59049 2.55837 5.75914 3.90864 4.40888C5.2589 3.05862 7.09025 2.30005 8.9998 2.30005C10.9094 2.30005 12.7407 3.05862 14.091 4.40888C15.4412 5.75914 16.1998 7.59049 16.1998 9.50005ZM9.89981 5.90005C9.89981 6.13874 9.80498 6.36766 9.6362 6.53645C9.46742 6.70523 9.2385 6.80005 8.9998 6.80005C8.76111 6.80005 8.53219 6.70523 8.36341 6.53645C8.19463 6.36766 8.0998 6.13874 8.0998 5.90005C8.0998 5.66135 8.19463 5.43244 8.36341 5.26365C8.53219 5.09487 8.76111 5.00005 8.9998 5.00005C9.2385 5.00005 9.46742 5.09487 9.6362 5.26365C9.80498 5.43244 9.89981 5.66135 9.89981 5.90005ZM8.0998 8.60005C7.86111 8.60005 7.63219 8.69487 7.46341 8.86365C7.29463 9.03244 7.1998 9.26135 7.1998 9.50005C7.1998 9.73874 7.29463 9.96766 7.46341 10.1364C7.63219 10.3052 7.86111 10.4 8.0998 10.4V13.1C8.0998 13.3387 8.19463 13.5677 8.36341 13.7364C8.53219 13.9052 8.76111 14 8.9998 14H9.89981C10.1385 14 10.3674 13.9052 10.5362 13.7364C10.705 13.5677 10.7998 13.3387 10.7998 13.1C10.7998 12.8614 10.705 12.6324 10.5362 12.4637C10.3674 12.2949 10.1385 12.2 9.89981 12.2V9.50005C9.89981 9.26135 9.80498 9.03244 9.6362 8.86365C9.46742 8.69487 9.2385 8.60005 8.9998 8.60005H8.0998Z",
            fill: color
        })
    });
};




var $61c5e07266db92dd$exports = {};
"use strict";
Object.defineProperty($61c5e07266db92dd$exports, "__esModule", {
    value: true
});
Object.defineProperty($61c5e07266db92dd$exports, "TickCircleFillIcon", {
    enumerable: true,
    get: function get() {
        return $e14e7c9728eb6852$exports.TickCircleFillIcon;
    }
});
var $e14e7c9728eb6852$exports = {};
"use strict";
Object.defineProperty($e14e7c9728eb6852$exports, "__esModule", {
    value: true
});
$e14e7c9728eb6852$exports.TickCircleFillIcon = void 0;

var $e14e7c9728eb6852$var$_react = $e14e7c9728eb6852$var$_interopRequireDefault($8Bz8p$react);


function $e14e7c9728eb6852$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $e14e7c9728eb6852$var$TickCircleFillIcon = $e14e7c9728eb6852$exports.TickCircleFillIcon = function TickCircleFillIcon(_ref) {
    var className = _ref.className, _ref$colorCode = _ref.colorCode, colorCode = _ref$colorCode === void 0 ? "a600" : _ref$colorCode, _ref$width = _ref.width, width = _ref$width === void 0 ? 18 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 19 : _ref$height;
    var theme = (0, $8Bz8p$styledcomponents.useTheme)();
    var color = theme.color[colorCode];
    return /*#__PURE__*/ (0, $8Bz8p$reactjsxruntime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 19",
        className: className,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8Bz8p$reactjsxruntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.00005 16.7C10.9096 16.7 12.741 15.9415 14.0912 14.5912C15.4415 13.241 16.2 11.4096 16.2 9.50005C16.2 7.59049 15.4415 5.75914 14.0912 4.40888C12.741 3.05862 10.9096 2.30005 9.00005 2.30005C7.09049 2.30005 5.25914 3.05862 3.90888 4.40888C2.55862 5.75914 1.80005 7.59049 1.80005 9.50005C1.80005 11.4096 2.55862 13.241 3.90888 14.5912C5.25914 15.9415 7.09049 16.7 9.00005 16.7ZM12.3363 8.33635C12.5003 8.16661 12.591 7.93927 12.589 7.70329C12.5869 7.46731 12.4923 7.24158 12.3254 7.07471C12.1585 6.90785 11.9328 6.81319 11.6968 6.81114C11.4608 6.80909 11.2335 6.89981 11.0637 7.06375L8.10005 10.0274L6.93635 8.86375C6.76661 8.69981 6.53927 8.60909 6.30329 8.61114C6.06731 8.61319 5.84158 8.70785 5.67471 8.87471C5.50784 9.04158 5.41319 9.26731 5.41114 9.50329C5.40909 9.73927 5.49981 9.96661 5.66375 10.1363L7.46375 11.9363C7.63252 12.1051 7.8614 12.1999 8.10005 12.1999C8.3387 12.1999 8.56757 12.1051 8.73635 11.9363L12.3363 8.33635Z",
            fill: color
        })
    });
};




var $6a2fcea392ba4a36$exports = {};
"use strict";
Object.defineProperty($6a2fcea392ba4a36$exports, "__esModule", {
    value: true
});
Object.defineProperty($6a2fcea392ba4a36$exports, "XFillCircleIcon", {
    enumerable: true,
    get: function get() {
        return $31dbe540f1e68306$exports.XFillCircleIcon;
    }
});
var $31dbe540f1e68306$exports = {};
"use strict";
Object.defineProperty($31dbe540f1e68306$exports, "__esModule", {
    value: true
});
$31dbe540f1e68306$exports.XFillCircleIcon = void 0;

var $31dbe540f1e68306$var$_react = $31dbe540f1e68306$var$_interopRequireDefault($8Bz8p$react);


function $31dbe540f1e68306$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $31dbe540f1e68306$var$XFillCircleIcon = $31dbe540f1e68306$exports.XFillCircleIcon = function XFillCircleIcon(_ref) {
    var className = _ref.className, _ref$colorCode = _ref.colorCode, colorCode = _ref$colorCode === void 0 ? "e600" : _ref$colorCode, _ref$width = _ref.width, width = _ref$width === void 0 ? 18 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 19 : _ref$height;
    var theme = (0, $8Bz8p$styledcomponents.useTheme)();
    var color = theme.color[colorCode];
    return /*#__PURE__*/ (0, $8Bz8p$reactjsxruntime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 19",
        className: className,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8Bz8p$reactjsxruntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.9998 16.7C10.9094 16.7 12.7407 15.9415 14.091 14.5912C15.4412 13.241 16.1998 11.4096 16.1998 9.50005C16.1998 7.59049 15.4412 5.75914 14.091 4.40888C12.7407 3.05862 10.9094 2.30005 8.9998 2.30005C7.09025 2.30005 5.2589 3.05862 3.90864 4.40888C2.55837 5.75914 1.7998 7.59049 1.7998 9.50005C1.7998 11.4096 2.55837 13.241 3.90864 14.5912C5.2589 15.9415 7.09025 16.7 8.9998 16.7ZM7.8361 7.06375C7.66636 6.89981 7.43902 6.80909 7.20304 6.81114C6.96707 6.81319 6.74134 6.90785 6.57447 7.07471C6.4076 7.24158 6.31295 7.46731 6.3109 7.70329C6.30885 7.93927 6.39956 8.16661 6.56351 8.33635L7.72721 9.50005L6.56351 10.6637C6.47755 10.7468 6.40898 10.8461 6.36181 10.9559C6.31465 11.0657 6.28982 11.1838 6.28878 11.3033C6.28774 11.4228 6.31051 11.5413 6.35577 11.6519C6.40102 11.7625 6.46785 11.863 6.55235 11.9475C6.63685 12.032 6.73734 12.0988 6.84795 12.1441C6.95855 12.1893 7.07706 12.2121 7.19657 12.2111C7.31607 12.21 7.43417 12.1852 7.54397 12.138C7.65377 12.0909 7.75308 12.0223 7.8361 11.9363L8.9998 10.7726L10.1635 11.9363C10.3332 12.1003 10.5606 12.191 10.7966 12.189C11.0325 12.1869 11.2583 12.0923 11.4251 11.9254C11.592 11.7585 11.6867 11.5328 11.6887 11.2968C11.6908 11.0608 11.6 10.8335 11.4361 10.6637L10.2724 9.50005L11.4361 8.33635C11.6 8.16661 11.6908 7.93927 11.6887 7.70329C11.6867 7.46731 11.592 7.24158 11.4251 7.07471C11.2583 6.90785 11.0325 6.81319 10.7966 6.81114C10.5606 6.80909 10.3332 6.89981 10.1635 7.06375L8.9998 8.22745L7.8361 7.06375Z",
            fill: color
        })
    });
};




var $ec397517eee808ea$var$MAP_ICON_WITH_TYPE = $ec397517eee808ea$exports.MAP_ICON_WITH_TYPE = {
    warning: $61c5e07266db92dd$exports.TickCircleFillIcon,
    alert: $6a2fcea392ba4a36$exports.XFillCircleIcon,
    info: $b2824a5fc00eb4c3$exports.InfoFillIcon
};
var $ec397517eee808ea$var$ICON_COLOR_MAP = $ec397517eee808ea$exports.ICON_COLOR_MAP = {
    warning: "a600",
    alert: "e600",
    info: "p500"
};



function $e02d8a7d375d9267$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $e02d8a7d375d9267$var$Note = $e02d8a7d375d9267$exports.Note = function Note(props) {
    var className = props.className, icon = props.icon, _props$showIcon = props.showIcon, showIcon = _props$showIcon === void 0 ? false : _props$showIcon, title = props.title, type = props.type, message = props.message, onClose = props.onClose, _props$classes = props.classes, classes = _props$classes === void 0 ? {
        title: "title",
        message: "message"
    } : _props$classes;
    var iconColorCode = $ec397517eee808ea$exports.ICON_COLOR_MAP[type];
    var Icon = icon || $ec397517eee808ea$exports.MAP_ICON_WITH_TYPE[type];
    var displayIcon = Boolean(icon) || showIcon;
    return /*#__PURE__*/ (0, $8Bz8p$reactjsxruntime.jsxs)($2569c38112180295$exports.Wrapper, {
        className: className,
        $type: type,
        children: [
            /*#__PURE__*/ (0, $8Bz8p$reactjsxruntime.jsxs)($2569c38112180295$exports.NoteHeader, {
                children: [
                    displayIcon && /*#__PURE__*/ (0, $8Bz8p$reactjsxruntime.jsx)($2569c38112180295$exports.PrefixIConWrapper, {
                        children: /*#__PURE__*/ (0, $8Bz8p$reactjsxruntime.jsx)(Icon, {
                            colorCode: iconColorCode,
                            height: 18,
                            width: 18
                        })
                    }),
                    title && /*#__PURE__*/ (0, $8Bz8p$reactjsxruntime.jsx)($2569c38112180295$exports.Title, {
                        $hasMessage: !!message,
                        className: classes === null || classes === void 0 ? void 0 : classes.title,
                        children: title
                    }),
                    onClose && /*#__PURE__*/ (0, $8Bz8p$reactjsxruntime.jsx)($2569c38112180295$exports.CloseIcon, {
                        colorCode: iconColorCode,
                        onClick: onClose,
                        width: 12,
                        height: 12,
                        stroke: 1.5
                    })
                ]
            }),
            message && /*#__PURE__*/ (0, $8Bz8p$reactjsxruntime.jsx)($2569c38112180295$exports.Message, {
                className: classes === null || classes === void 0 ? void 0 : classes.message,
                $hasTitle: !!title,
                children: message
            })
        ]
    });
};




//# sourceMappingURL=index.js.map
